export default "__VITE_ASSET__N8n97McL__"